import React, {useEffect, useState} from 'react'
import {toAbsoluteUrl, KTSVG} from '../../../../../_metronic/helpers'
import ReactApexChart from 'react-apexcharts'
import {useDispatch, useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import {
  GetOptOutLineData,
  GetOptOutSurveyData,
  GetOptOutTableData,
  GetReportId,
  GetSingleMessageData,
  getOptoutLineData,
  getOptoutSurveyGraph,
  getOptoutTableReport,
} from '../reportSlices/reportAnalytics'
import ReactPaginate from 'react-paginate'
import moment from 'moment'
import NodataYet from '../../../../Components/NodataYet'
import {OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import {useLazyGetCampaignReportCustomerOptoutExportQuery, useSubscribeContactMutation, useUnSubscribeContactMutation} from '../../../../../services/cellcast'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import {
  getDefaultRegion,
} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {
  useFetchReportPaginateListGroupQuery,
  useGetReportLineChartsQuery,
} from '../../../../../services/cellcast.v3'
import { REGION } from '../../../../Utils/Constant/ConstantForWebsite'
import { AuthenticateUser } from '../../../../Utils/_helpers/RoleAndPermission'
const API_DOMAIN = ENV().REACT_APP_DOMAIN

const OptOutTabRegion = () => {
  const ReportId = useSelector(GetReportId)
  const messageData = ReportId?.data
  const optoutTableData = useSelector(GetOptOutTableData)
  const optoutSurvey = useSelector(GetOptOutSurveyData)

  const today = new Date() // Current date
  const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)
  const [dateRange, setDateRange] = useState<any>([sevenDaysAgo, new Date()])

  const [startDate, endDate] = dateRange

  const [search, setSearch] = useState({
    searchValue: '',
    page: 1,
  })

  const {data, isLoading} = useFetchReportPaginateListGroupQuery({
    page: search.page,
    limit: 10,
    scope: 'unsubscribe',
    type: 'contact',
    group: 'metadata.contactId',
    bulkId: ReportId?.id,
  })

  const {data: linechartData} = useGetReportLineChartsQuery({
    fromDate: moment(startDate).format('YYYY-MM-DD'),
    toDate: moment(endDate).format('YYYY-MM-DD'),
    scope: 'unsubscribe',
    type: 'contact',
    bulkId: ReportId?.id,
  })

  const optoutData: any = {
    series: [
      messageData?.unsubscribe_count,
      messageData?.total_recipient - messageData?.unsubscribe_count,
    ],

    options: {
      chart: {
        type: 'donut',
      },
      labels: ['Unsubscribed', 'Active'],
      colors: ['rgb(238, 76, 76)', 'rgb(76, 238, 189)'],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    },
  }

  const surveyLabel =
    optoutSurvey?.[0]?.options?.map((key: any) => `${key?.option} (${Math.ceil(key?.percentage)}%)`) || []
  const surveySeries =
    optoutSurvey?.[0]?.options?.map((key: any) => Math.ceil(key?.percentage)) || []
  const optoutSurveyData: any = {
    series: surveySeries,

    options: {
      chart: {
        type: 'donut',
      },
      labels: surveyLabel,

      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    },
  }
  const lineSeries =
    linechartData?.data?.items?.map((key: any) => [
      +moment.utc(key?._id)?.format('x'),
      +key?.count,
    ]) || []

  const lineData: any = {
    series: [
      {
        name: 'optout',
        data: lineSeries,
      },
    ],
    options: {
      chart: {
        type: 'area',
        stacked: false,
        height: 350,
        zoom: {
          type: 'x',
          enabled: true,
          autoScaleYaxis: true,
        },
        toolbar: {
          autoSelected: 'zoom',
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      title: {
        text: '',
        align: 'left',
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.5,
          opacityTo: 0,
          stops: [0, 90, 100],
        },
      },
      yaxis: {
        labels: {
          formatter: function (val: any) {
            return val?.toFixed(0)
          },
        },
        title: {
          text: '',
        },
      },
      xaxis: {
        type: 'datetime',
      },
      tooltip: {
        shared: false,
        y: {
          formatter: function (val: any) {
            return val?.toFixed(0)
          },
        },
      },
    },
  }

  return (
    <>
      <div className='row mx-n4'>
        <div className='col-md-6 px-4 mb-8 mb-md-0'>
          <div className='card p-8 py-5 h-100'>
            <div className='card-header border-0 p-0 align-items-center'>
              <h3 className='card-title align-items-start  flex-column'>
                <span className='card-label fw-bolder fs-2 mb-1'>Opt-out summary</span>
                <span className='text-muted mt-1 fw-bold fs-7'>
                  Customers are automatically unsubscribed
                </span>
              </h3>
            </div>
            <div className='card-body px-0 pt-5'>
              <div className='optout_summary_chart'>
                <div className='chart_body'>
                  {/* <img src={toAbsoluteUrl('/media/misc/optout_summary_chart.png')} alt='Image' /> */}
                  <ReactApexChart
                    options={optoutData.options}
                    series={optoutData.series}
                    type='donut'
                  />
                  <div className='optout_unsubscribed'>
                    <p>Recipients who responded negativelly will also be unsubscribed.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-6 px-4'>
          <div className='card p-8 py-5 h-100'>
            <div className='card-header border-0 p-0 align-items-center'>
              <h3 className='card-title align-items-start  flex-column'>
                <span className='card-label fw-bolder fs-2 mb-1'>Opt-out over time</span>
                <span className='text-muted mt-1 fw-bold fs-7'>
                  Total Unsubscribed ({messageData?.unsubscribe_count})
                </span>
              </h3>
            </div>
            <div className='card-body px-0 pt-5'>
              <div className='optout_summary_chart'>
                {linechartData?.data?.items?.length ? (
                  <div className='chart_body'>
                    {/* <img src={toAbsoluteUrl('/media/misc/optout_overtime_chart.png')} alt='Image' /> */}
                    <ReactApexChart
                      options={lineData.options}
                      series={lineData.series}
                      type='area'
                      height={350}
                    />
                  </div>
                ) : (
                  <NodataYet />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='row mx-n4 mt-8'>
        {optoutTableData?.data?.isSurvey && (
          <>
            <div className='col-md-4 px-4 mb-8 mb-md-0'>
              <div className='card p-8 py-5 h-100'>
                <div className='card-header border-0 p-0 align-items-center'>
                  <h3 className='card-title align-items-start  flex-column'>
                    <span className='card-label fw-bolder fs-2 mb-1'>Custom survey</span>
                    <span className='text-muted mt-1 fw-bold fs-7'>Options breakdown</span>
                  </h3>
                </div>
                <div className='card-body px-0 pt-5'>
                  <div className='optout_summary_chart'>
                    <div className='chart_body'>
                      <ReactApexChart
                        options={optoutSurveyData.options}
                        series={optoutSurveyData.series}
                        type='donut'
                      />
                      {/* <img src={toAbsoluteUrl('/media/misc/customer_survey_chart.png')} alt='Image' /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-8 px-4'>
              <div className='card p-8 py-5 h-100'>
                <div className='card-header border-0 p-0 align-items-center'>
                  <h3 className='card-title align-items-start  flex-column'>
                    <span className='card-label fw-bolder fs-2 mb-1'>Custom survey</span>
                    <span className='text-muted mt-1 fw-bold fs-7'>Options breakdown</span>
                  </h3>
                </div>
                <div className='card-body px-0 pt-5'>
                  <div className='row'>
                    <div className='col-md-8 mb-8 mb-md-0'>
                      <div className='table-responsive'>
                        <table className='table align-middle gs-0 gy-5'>
                          <thead>
                            <tr className='fw-400 text-muted '>
                              <th>CUSTOM FIELD</th>
                              <th>Count</th>
                              <th>PERCENTAGE</th>
                            </tr>
                          </thead>
                          <tbody>
                            {optoutSurvey?.[0]?.options?.map((key: any, i: number) => (
                              <tr key={i} className='border-dashed border-2 border-bottom'>
                                <td>{key?.option}</td>
                                <td>{key?.count}</td>
                                <td>{Math.ceil(key?.percentage)}%</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div
                        className='mobile-bg-wrapper grey-bg new_mobile mb-0 customer_survey_mobile'
                        style={{
                          backgroundImage: `url(${toAbsoluteUrl(
                            '/media/mobile/customer_survey_mobile.png'
                          )})`,
                        }}
                      >
                        <div className='mobile-inner'>
                          <div className='mobile-head'>
                            <strong className='msg-mobile-title p-6 d-block text-center px-12'>
                              <KTSVG
                                className='svg-icon-8'
                                path='/media/icons/duotune/arrows/mobile_left_arrow.svg'
                              />
                              {''}
                            </strong>
                          </div>
                          <div className='mobile-body'>
                            <div
                              style={{backgroundColor: '#f7f8fa'}}
                              className='inner-content-main'
                            >
                              <h5>Opt-out survey</h5>
                              <p>
                                We're sorry to see you go! Are you still interested in any of these
                                contents?
                              </p>

                              <div className='form-check form-check-custom form-check-sm form-check-solid ms-3 mt-3'>
                                {optoutSurvey?.[0]?.options?.map((key: any, index: number) => (
                                  <div className='row w-100' key={index}>
                                    <input
                                      className='form-check-input mb-3 col-2'
                                      type='radio'
                                      id='flexRadioChecked'
                                      value=''
                                      checked
                                    />
                                    <label
                                      className='form-check-label align-items-start flex-column d-flex ms-0 col-9'
                                      htmlFor='flexRadioChecked'
                                    >
                                      <span className='card-label'>{key?.option}</span>
                                    </label>
                                  </div>
                                ))}
                              </div>

                              <form action=''>
                                <label className='fs-10'>What number you'd like to unsub?</label>
                                <input
                                  type='text'
                                  placeholder='Enter your phone number'
                                  className='form-control fs-10 p-2'
                                />

                                <button
                                  className='btn btn-sm gray_bg_purple mt-5 px-3'
                                  style={{fontSize: '8px'}}
                                >
                                  Submit and Unsubscribe
                                </button>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className='row mt-8'>
        <div className='col-12'>
          <div className='card mb-0 pt-7'>
            <div className='card-header align-items-center border-bottom-0'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-2 mb-1'>All opt-outs</span>
                <span className='text-muted mt-1 fw-bold fs-7'>
                  See all your opt-outs in one place
                </span>
              </h3>
            </div>
            <div className='card-body pt-2'>
              {data?.data?.items?.length > 0 ? (
                <div className='tab-content'>
                  <div className='table-responsive'>
                    <table className='table align-middle gs-0 gy-5'>
                      <thead>
                        <tr className='fw-bold text-muted text-uppercase'>
                          <th>Mobile</th>
                          <th>First Name</th>
                          <th>Full Name</th>
                          <th>Date</th>
                          <th>Time</th>
                          <th>Unsub via</th>
                          <th className='w-200px'>Messsage</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody className='text-gray-600'>
                        {data?.data?.items?.map((key: any, i: number) => (
                          <tr key={i} className='border-dashed border-1 border-bottom'>
                            <td>{key?.metadata?.contact_number}</td>
                            <td>{key?.metadata?.contact_name || '-'}</td>
                            <td>{key?.metadata?.contact_name || '-'}</td>
                            <td>{moment(key?.created_at)?.format('l')}</td>
                            <td>{moment(key?.created_at)?.format('LT')}</td>
                            <td>Reply</td>
                            <td>
                              {/* {JSON.stringify(key?.selectedOptions)} */}

                              {key?.unsubVia === 'Survey' ? (
                                <ul>{/* TODO: add unsubvia */}</ul>
                              ) : (
                                key?.message || 'STOP'
                              )}
                            </td>
                            {/* <td>
                            <a className='badge badge-light-pink fw-bold '>Reply STOP</a>
                          </td> */}
                            {/* <td>Stop</td> */}
                            <td>
                              <a className='badge badge-light-danger fw-bold '>Unsubscribed</a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <NodataYet message={'No opt-outs yet'} />
              )}

              <div className='abcd '>
                <span>Total: {data?.data?.total}</span>
                <ReactPaginate
                  previousLabel='<'
                  nextLabel='>'
                  pageCount={data?.data?.totalPages}
                  onPageChange={(e) => setSearch({...search, page: e.selected + 1})}
                  containerClassName={'pagiantion'}
                  previousLinkClassName={'pagination__link'}
                  nextLinkClassName={'pagination__link'}
                  disabledClassName={'pagination__link--disabled'}
                  activeClassName={'pagination__link--active'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const OptOutTabDefault = () => {
  const dispatch = useDispatch()
  const messageData = useSelector(GetSingleMessageData)
  const ReportId = useSelector(GetReportId)
  const optoutTableData = useSelector(GetOptOutTableData)
  const optoutSurvey = useSelector(GetOptOutSurveyData)
  const optoutLine = useSelector(GetOptOutLineData)
  
  const [subscribeContact, {isLoading: subscribeLoading}] = useSubscribeContactMutation()
  const [unsubscribeContact, {isLoading: isUnsubscribeLoading}] = useUnSubscribeContactMutation()

  const [getCampaignReportCustomerOptoutExport, {isFetching: isFetchDownload}] =
    useLazyGetCampaignReportCustomerOptoutExportQuery()

  const onClickSubscribeHandler = (id: any) => {
    subscribeContact({contactIDs: [id]})
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)
          window.location.reload();
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error subscribe:', res.error)
        }
      })
      .catch((err) => {
        toast.error(err.error)
      })
  }

  const onClickUnsubscribeHandler = (id: any) => {
    unsubscribeContact({contactIDs: [id]})
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)
          window.location.reload();
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error unsubscribe:', res.error)
        }
      })
      .catch((err: any) => {
        toast.error(err.error)
      })
  }

  const getSurveyOptions = optoutSurvey?.map((item: any) => {
    const firstOptList = item?.optoutlists?.[0];

    const hasOptList = !!firstOptList?.options?.length;

    const labelMap = hasOptList
      ? firstOptList.options.reduce((acc: any, obj: any) => {
          const key = Object.keys(obj)[0];
          acc[key] = obj[key];
          return acc;
        }, {})
      : {};

    const updatedOptions = item?.options?.map((option: any) => ({
      ...option,
      option: hasOptList
        ? labelMap?.[option.option] || option.option
        : firstOptList?.title || option.option // fallback
    }));

    return {
      ...item,
      options: updatedOptions
    };
  }) || [];

  const getDefaultSurveyOptions = (options: any) => {
    const firstSurvey = getSurveyOptions?.[0];
    const firstOptList = firstSurvey?.optoutlists?.[0];
    return firstOptList?.options?.length ? options : firstOptList?.title || options;
  };

  const [search, setSearch] = useState({
    searchValue: '',
    page: 1,
  })
  const optoutData: any = {
    series: [messageData?.unsub + messageData?.gatewaymessagesreplyStop, messageData?.recipients - (messageData?.unsub + messageData?.gatewaymessagesreplyStop)],

    options: {
      chart: {
        type: 'donut',
      },
      labels: ['Unsubscribed', 'Active'],
      colors: ['rgb(238, 76, 76)', 'rgb(76, 238, 189)'],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    },
  }
  const surveyLabel =
  getSurveyOptions?.[0]?.options?.map((key: any) => `${key?.option} (${key?.count})`) || []
  const surveySeries =
    getSurveyOptions?.[0]?.options?.map((key: any) => Math.ceil(key?.percentage)) || []
  const optoutSurveyData: any = {
    series: surveySeries,

    options: {
      chart: {
        type: 'donut',
      },
      labels: surveyLabel,
      legend: {
        position: 'bottom',
        fontSize: '12px',
        horizontalAlign: 'left'
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    },
  }
  const lineSeries =
    optoutLine?.data?.map((key: any) => [+moment.utc(key?._id)?.format('x'), +key?.count]) || []

  const lineData: any = {
    series: [
      {
        name: 'optout',
        data: lineSeries,
      },
    ],
    options: {
      chart: {
        type: 'area',
        stacked: false,
        height: 350,
        zoom: {
          type: 'x',
          enabled: true,
          autoScaleYaxis: true,
        },
        toolbar: {
          autoSelected: 'zoom',
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      title: {
        text: '',
        align: 'left',
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.5,
          opacityTo: 0,
          stops: [0, 90, 100],
        },
      },
      yaxis: {
        labels: {
          formatter: function (val: any) {
            return val?.toFixed(0)
          },
        },
        title: {
          text: '',
        },
      },
      xaxis: {
        type: 'datetime',
      },
      tooltip: {
        shared: false,
        y: {
          formatter: function (val: any) {
            return val?.toFixed(0)
          },
        },
      },
    },
  }

  useEffect(() => {
    dispatch(
      getOptoutTableReport({id: ReportId?.id, params: {camp_type: ReportId?.camp_type, ...search}})
    )
  }, [search])

  useEffect(() => {
    dispatch(getOptoutSurveyGraph({id: ReportId?.id, params: {camp_type: ReportId?.camp_type}}))
    dispatch(getOptoutLineData({id: ReportId?.id, params: {camp_type: ReportId?.camp_type}}))
  }, [])

  return (
    <>
      <div className='row mx-n4'>
        <div className='col-md-6 px-4 mb-8 mb-md-0'>
          <div className='card p-8 py-5 h-100'>
            <div className='card-header border-0 p-0 align-items-center'>
              <h3 className='card-title align-items-start  flex-column'>
                <span className='card-label fw-bolder fs-2 mb-1'>Opt-out summary</span>
                <span className='text-muted mt-1 fw-bold fs-7'>
                  Customers are automatically unsubscribed
                </span>
              </h3>
            </div>
            <div className='card-body px-0 pt-5'>
              <div className='optout_summary_chart'>
                <div className='chart_body'>
                  {/* <img src={toAbsoluteUrl('/media/misc/optout_summary_chart.png')} alt='Image' /> */}
                  <ReactApexChart
                    options={optoutData.options}
                    series={optoutData.series}
                    type='donut'
                  />
                  <div className='optout_unsubscribed'>
                    <p>Recipients who responded negativelly will also be unsubscribed.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-6 px-4'>
          <div className='card p-8 py-5 h-100'>
            <div className='card-header border-0 p-0 align-items-center'>
              <h3 className='card-title align-items-start  flex-column'>
                <span className='card-label fw-bolder fs-2 mb-1'>Opt-out over time</span>
                <span className='text-muted mt-1 fw-bold fs-7'>
                  Total Unsubscribed ({messageData?.unsub + messageData?.gatewaymessagesreplyStop})
                </span>
              </h3>
            </div>
            <div className='card-body px-0 pt-5'>
              <div className='optout_summary_chart'>
                {optoutLine?.data?.length > 0 ? (
                  <div className='chart_body'>
                    {/* <img src={toAbsoluteUrl('/media/misc/optout_overtime_chart.png')} alt='Image' /> */}
                    <ReactApexChart
                      options={lineData.options}
                      series={lineData.series}
                      type='area'
                      height={350}
                    />
                  </div>
                ) : (
                  <NodataYet />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='row mx-n4 mt-8'>
        {optoutTableData?.data?.isSurvey && (
          <>
            <div className='col-md-4 px-4 mb-8 mb-md-0'>
              <div className='card p-8 py-5 h-100'>
                <div className='card-header border-0 p-0 align-items-center'>
                  <h3 className='card-title align-items-start  flex-column'>
                    <span className='card-label fw-bolder fs-2 mb-1'>Custom survey</span>
                    <span className='text-muted mt-1 fw-bold fs-7'>Options breakdown</span>
                  </h3>
                </div>
                <div className='card-body px-0 pt-5'>
                  <div className='optout_summary_chart'>
                    <div className='chart_body'>
                      <ReactApexChart
                        options={optoutSurveyData.options}
                        series={optoutSurveyData.series}
                        type='donut'
                        height={300}
                      />
                      {/* <img src={toAbsoluteUrl('/media/misc/customer_survey_chart.png')} alt='Image' /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-8 px-4'>
              <div className='card p-8 py-5 h-100'>
                <div className='card-header border-0 p-0 align-items-center'>
                  <h3 className='card-title align-items-start  flex-column'>
                    <span className='card-label fw-bolder fs-2 mb-1'>Custom survey</span>
                    <span className='text-muted mt-1 fw-bold fs-7'>Options breakdown</span>
                  </h3>
                </div>
                <div className='card-body px-0 pt-5'>
                  <div className='row'>
                    <div className='col-md-8 mb-8 mb-md-0'>
                      <div className='table-responsive'>
                        <table className='table align-middle gs-0 gy-5'>
                          <thead>
                            <tr className='fw-400 text-muted '>
                              <th>CUSTOM FIELD</th>
                              <th>Count</th>
                              <th>PERCENTAGE</th>
                            </tr>
                          </thead>
                          <tbody>
                            {getSurveyOptions && getSurveyOptions?.[0]?.options?.map((key: any, i: number) => (
                              <tr key={i} className='border-dashed border-2 border-bottom'>
                                <td>{key?.option}</td>
                                <td>{key?.count}</td>
                                <td>{Math.ceil(key?.percentage)}%</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div
                        className='mobile-bg-wrapper grey-bg new_mobile mb-0 customer_survey_mobile'
                        style={{
                          backgroundImage: `url(${toAbsoluteUrl(
                            '/media/mobile/customer_survey_mobile.png'
                          )})`,
                        }}
                      >
                        <div className='mobile-inner'>
                          <div className='mobile-head'>
                            <strong className='msg-mobile-title p-6 d-block text-center px-12'>
                              <KTSVG
                                className='svg-icon-8'
                                path='/media/icons/duotune/arrows/mobile_left_arrow.svg'
                              />
                              {''}
                            </strong>
                          </div>
                          <div className='mobile-body'>
                            <div
                              style={{backgroundColor: '#f7f8fa'}}
                              className='inner-content-main'
                            >
                              <h5>Opt-out survey</h5>
                              <p>
                                We're sorry to see you go! Are you still interested in any of these
                                contents?
                              </p>

                              <div className='form-check form-check-custom form-check-sm form-check-solid ms-3 mt-3 d-flex flex-column'>
                                {getSurveyOptions && getSurveyOptions?.[0]?.options?.map((key: any, index: number) => (
                                  <div className='row w-100' key={index} style={{display: key?.option?.toLowerCase() === 'stop link' ? 'none' : ''}}>
                                    <input
                                      className='form-check-input mb-3 col-2'
                                      type='radio'
                                      id='flexRadioChecked'
                                      value=''
                                      checked
                                    />
                                    <label
                                      className='form-check-label align-items-start flex-column d-flex ms-0 col-9'
                                      htmlFor='flexRadioChecked'
                                    >
                                      <span className='fw-bold fs-10'>{key?.option}</span>
                                    </label>
                                  </div>
                                ))}
                              </div>

                              <form action=''>
                                <label className='fs-10'>What number you'd like to unsub?</label>
                                <input
                                  type='text'
                                  placeholder='Enter your phone number'
                                  className='form-control fs-10 p-2'
                                />

                                <button
                                  className='btn btn-sm gray_bg_purple mt-5 px-3'
                                  style={{fontSize: '8px'}}
                                >
                                  Submit and Unsubscribe
                                </button>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className='row mt-8'>
        <div className='col-12'>
          <div className='card mb-0 pt-7'>
            <div className='card-header align-items-center border-bottom-0'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-2 mb-1'>All opt-outs</span>
                <span className='text-muted mt-1 fw-bold fs-7'>
                  See all your opt-outs in one place
                </span>
              </h3>
              {optoutTableData?.data?.items?.length > 0 && (
                <button
                  disabled={isFetchDownload}
                  onClick={() =>
                    getCampaignReportCustomerOptoutExport({
                      campId: ReportId?.id,
                      campType: ReportId?.camp_type,
                      exportData: true,
                    })
                      .unwrap()
                      .then((res: any) =>
                        window.open(`${API_DOMAIN}${res?.data?.downloadurl}`, '_self')
                      )
                      .catch()
                  }
                  type='button'
                  className='btn btn-light-primary me-3'
                >
                  {' '}
                  {isFetchDownload ? (
                    <Spinner size='sm' className='p-0' />
                  ) : (
                    <>
                      <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
                      Export
                    </>
                  )}
                </button>
              )}
            </div>
            <div className='card-body pt-2'>
              {optoutTableData?.data?.items?.length > 0 ? (
                <div className='tab-content'>
                  <div className='table-responsive'>
                    <table className='table align-middle gs-0 gy-5'>
                      <thead>
                        <tr className='fw-bold text-muted text-uppercase'>
                          <th>Mobile</th>
                          <th>First Name</th>
                          <th>Full Name</th>
                          <th>Date</th>
                          <th>Time</th>
                          <th>Unsub via</th>
                          <th>Option Selected</th>
                          <th className='w-200px'>Customer Reply</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody className='text-gray-600'>
                        {optoutTableData && optoutTableData?.data?.items?.map((key: any, i: number) => (
                          <tr key={i} className='border-dashed border-1 border-bottom'>
                            <td>{key?.mobile}</td>
                            <td>
                              {key?.fields?.find(
                                (key: any) =>
                                  key?.name?.toLowerCase()?.replace(/ +/g, '') === 'firstname'
                              )
                                ? key?.fields?.find(
                                    (key: any) =>
                                      key?.name?.toLowerCase()?.replace(/ +/g, '') === 'firstname'
                                  )?.value
                                : '-'}
                            </td>
                            <td>
                              {key?.fields?.find(
                                (key: any) =>
                                  key?.name?.toLowerCase()?.replace(/ +/g, '') === 'fullname'
                              )
                                ? key?.fields?.find(
                                    (key: any) =>
                                      key?.name?.toLowerCase()?.replace(/ +/g, '') === 'fullname'
                                  )?.value
                                : '-'}
                            </td>
                            <td>{moment(key?.customerResponseAt)?.format('l')}</td>
                            <td>{moment(key?.customerResponseAt)?.format('LT')}</td>
                           <td>
                              {key?.optout?.toLowerCase() === 'stop link'
                                ? key.optout
                                : key?.optout
                                  ? `Survey ${key.optout}`
                                  : 'Reply stop'}
                            </td>
                            <td>
                              {key?.optoutData?.length > 0 ? (
                                <ul>
                                  { key?.optoutData?.map((val: any, index: number) => {
                                    return key?.selectedOptions
                                      .filter((it: any) => it)
                                      .map((it: any) => {
                                        return val[it] && <li>{val[it]}</li>
                                      })
                                  })}
                                </ul>
                              ) : getDefaultSurveyOptions(key?.selectedOptions)}
                            </td>
                            <td>
                              {/* {JSON.stringify(key?.selectedOptions)} */}

                              {key?.message}
                            </td>
                            {/* <td>
                            <a className='badge badge-light-pink fw-bold '>Reply STOP</a>
                          </td> */}
                            {/* <td>Stop</td> */}
                            <td>
                              <span
                                className={
                                  key?.isBlocked === true || key?.isBlockedByUser === true
                                    ?  'badge badge badge-light-danger fw-bold  fs-7  badge-square p-4  py-5' : 'badge badge-light-success green_text_badge badge-square p-4  py-5' 
                                }
                              >
                                {key?.isBlocked === true || key?.isBlockedByUser === true
                                  ? 'Unsubscribed' : 'Subscribed'}
                              </span>
                            </td>
                            <td>
                            {key?.isBlocked === true || key?.isBlockedByUser === true
                              ? (
                                <OverlayTrigger
                                    placement='bottom'
                                    delay={{show: 250, hide: 400}}
                                    overlay={<Tooltip id='tooltip-bottom'>Subscribe</Tooltip>}
                                  >
                                    <span
                                      className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                      onClick={() => {
                                        onClickSubscribeHandler(key?.contactId ?? key?._id)
                                      }}
                                    >
                                      {key.contactId && subscribeLoading ? (
                                        <Spinner />
                                      ) : (
                                        AuthenticateUser('edit-contact') && (
                                          <i className='bi bi-person-fill-add fs-5 text-success'></i>
                                        )
                                      )}
                                    </span>
                                </OverlayTrigger>
                              ) : (
                                <OverlayTrigger
                                    placement='bottom'
                                    delay={{show: 250, hide: 400}}
                                    overlay={<Tooltip id='tooltip-bottom'>Unsubscribe</Tooltip>}
                                  >
                                    <span
                                      className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                      onClick={() => {
                                        onClickUnsubscribeHandler(key?.contactId ?? key?._id)
                                      }}
                                    >
                                      {key.contactId && isUnsubscribeLoading ? (
                                        <Spinner />
                                      ) : (
                                        AuthenticateUser('edit-contact') && (
                                          <i className='bi bi-person-fill-dash fs-5 text-danger'></i>
                                        )
                                      )}
                                    </span>
                                </OverlayTrigger>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className='abcd '>
                    <span>Total: {optoutTableData?.data?.total}</span>
                    <ReactPaginate
                      previousLabel='<'
                      nextLabel='>'
                      pageCount={optoutTableData?.data?.totalPages}
                      onPageChange={(e) => setSearch({...search, page: e.selected + 1})}
                      containerClassName={'pagiantion'}
                      previousLinkClassName={'pagination__link'}
                      nextLinkClassName={'pagination__link'}
                      disabledClassName={'pagination__link--disabled'}
                      activeClassName={'pagination__link--active'}
                    />
                  </div>
                </div>
              ) : (
                <NodataYet message={'No opt-outs yet'} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const OptOutTab = () => {
  const currentRegion = useSelector(getDefaultRegion)

  if ([REGION.AU].includes(currentRegion)) {
    return <OptOutTabDefault />
  } else {
    return <OptOutTabRegion />
  }
}

export default OptOutTab
